import { QueryClient, useQuery, UseQueryResult } from '@tanstack/react-query';
import EligibilityService from 'src/services/eligibility.service';
import { PlanType } from 'src/types/user.model';
import { EligibilityModel } from 'src/types/eligibility.model';

export const eligibilityQueryKey: string = 'eligibility';

export const useEligibility = (planType: PlanType): UseQueryResult<EligibilityModel> => {
    return useQuery<EligibilityModel>({
        queryKey: [eligibilityQueryKey],
        queryFn: async (): Promise<EligibilityModel> => await EligibilityService.getEligibility(planType),
        staleTime: 30 * (60 * 1000), // 30 minutes
        cacheTime: 45 * (60 * 1000) // 45 minutes
    });
};

export const invalidateEligibility = async (queryClient: QueryClient): Promise<void> => {
    await queryClient.invalidateQueries([eligibilityQueryKey]);
};
